import { createContext } from "react";

enum viewTypes {
    Home = 1,
    TaskList,
    DataBase,
    Communication,
    Dictionaries,
    Administration,
    KRForm,
    POForm,
    CollectiveEditForm,
    CollectiveEditFormLocal
}

const ViewContext = createContext({
    viewTypes: viewTypes,
    viewType: viewTypes.Home,
    setViewType: (viewType: number) => {},
    viewData: null,
    setViewData: (viewData: any) => {},
    krFormSavePrompt: false,
    setKrFormSavePrompt: (save: boolean) => {},
    krFormCallback: function () {},
    setKrFormCallback: (func: () => void) => {},
    localView: false,
    setLocalView: (local: boolean) => {},
    setSavingLocal: (savingLocal: boolean) => {},
    savingLocal: false
});

export default ViewContext;